<template>
  <div class="alur-verifikasi-section">
    <h4 class="alur-title">Alur Verifikasi Surat</h4>
    <p class="alur-description">{{ alurText }}</p>
  </div>
</template>

<script>
import { defineComponent, computed } from 'vue'
import { useStore } from 'vuex'

export default defineComponent({
  name: 'AlurVerifikasi',
  props: {
    verifikator: {
      type: Array,
      default: () => [],
    },
  },
  setup(props) {
    const store = useStore()

    // Get pengurus options for name lookup
    const pengurusOptions = computed(() => store.state.suratKeluar.pengurusOptions || [])

    // Find user name by userId from pengurusOptions
    const getUserNameById = (userId) => {
      if (!userId) return null
      const pengurus = pengurusOptions.value.find(p => p.value === userId)
      return pengurus ? pengurus.label : null
    }

    const alurText = computed(() => {
      if (!props.verifikator || props.verifikator.length === 0) {
        return 'Belum ada verifikator'
      }

      // Filter out entries without userId
      const validVerifikator = props.verifikator.filter(v => v.userId || v.user)

      if (validVerifikator.length === 0) {
        return 'Belum ada verifikator'
      }

      const parts = validVerifikator.map((v, index) => {
        // Try to get name from user object first (detail page), then by userId lookup (create page)
        let userName = v.user?.name || getUserNameById(v.userId) || 'Belum dipilih'
        return `${userName} (Verifikator ${index + 1})`
      })

      return parts.join(' → ') + ' → Selesai Verifikasi & Masuk Proses Penandatanganan'
    })

    return {
      alurText,
    }
  },
})
</script>

<style lang="scss" scoped>
.alur-verifikasi-section {
  background: #eeeaff;
  border: 1px solid #321E8D;
  border-radius: 8px;
  padding: 16px;
  margin: 24px 0;

  .alur-title {
    font-size: 14px;
    font-weight: 600;
    color: #321E8D;
    margin: 0 0 8px 0;
  }

  .alur-description {
    font-size: 13px;
    color: #262626;
    margin: 0;
    line-height: 1.5;
  }
}
</style>
